var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { classes, st } from './AvatarGroup.base.st.css';
export function AvatarGroupBase(_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, avatarContainerClassName = _a.avatarContainerClassName, renderAvatar = _a.renderAvatar, _c = _a.maxAmount, maxAmount = _c === void 0 ? 5 : _c, className = _a.className, rest = __rest(_a, ["items", "avatarContainerClassName", "renderAvatar", "maxAmount", "className"]);
    return (React.createElement("div", __assign({ className: st(classes.root, className) }, rest), items.slice(0, maxAmount).map(function (props, i) { return (React.createElement("div", { className: st(classes.avatarContainer, avatarContainerClassName), key: "".concat(props.src, "-").concat(i, "-").concat(props.name) }, renderAvatar(props))); })));
}
//# sourceMappingURL=AvatarGroup.base.js.map